<template>
  <div>
      <b-row>
        <b-colxx xxs="12">
            <piaf-breadcrumb :heading="$t('menu.NoticeList')"/>
            <div class="separator mb-5"></div>
        </b-colxx>
      </b-row>

      <b-row>
      <b-colxx xxs="12">
        <b-card class="mb-4" title="공지사항">
        <b-row class="mb-2">
            <b-colxx xxs="12" md="4" lg="3" xl="3" class="pr-0">
            <div class="form-group has-float-label">
              <v-select :options="searchOption" v-model="searchValue" :reduce="item=>item.value" label="label" ></v-select>
              <span>검색유형</span>
            </div>
          </b-colxx>

          <b-colxx xxs="12" md="6" lg="4" xl="4">
              <b-input-group class="mb-3">
                <b-input :placeholder="searchPlaceholder" v-model="search" @keyup.enter="popupPageing"/>

                <b-input-group-append>
                  <b-button  @click="popupPageing" variant="outline-primary default">
                    {{$t('button.search')}}
                  </b-button>
                </b-input-group-append>

              </b-input-group>
          </b-colxx>
        </b-row>
          <b-row class="mb-5">
            <b-col xxs="12">
                <notice-list-child
                    :items="items"
                    :totalsNum="totalsNum"
                    :isSizePnotice="isSizePnotice"
                    :isNumPnotice="isNumPnotice"
                    :fields="fields"
                    :per-page="perPage"
                    :current-page="currentPage"
                />
                
                <b-pagination 
                    v-if="lastPage > 1"
                    size="sm"
                    align="center"
                    :total-rows="total"
                    :per-page="perPage"
                    v-model="currentPage"
                    aria-controls="noticeNo"
                >
                    <template v-slot:next-text>
                        <i class="simple-icon-arrow-right"/>
                    </template>
                    <template v-slot:prev-text>
                        <i class="simple-icon-arrow-left"/>
                    </template>
                    <template v-slot:first-text>
                        <i class="simple-icon-control-start"/>
                    </template>
                    <template v-slot:last-text>
                        <i class="simple-icon-control-end"/>
                    </template>
                </b-pagination>
            </b-col>
          </b-row>
        </b-card>
      </b-colxx>
      </b-row>
  </div>
</template>

<script>
import mixin from '../../utils/mixins';
import NoticeListChild from './components/NoticeListChild';

import vSelect from 'vue-select'

export default {
    mixins: [mixin],
    components:{
        'notice-list-child': NoticeListChild,
        'v-select': vSelect
    },
    watch: {
        currentPage: {
           handler: function(value) {
              this.popupPageing();
            }
          },
    },
    mounted(){
        this.popupPageing()
    },
    methods:{
    }
}
</script>